<template>
  <div class="flex h-full flex-col">
    <ClientOnly>
      <div v-show="isOpen" class="relative flex-1">
        <div
          id="rx-fitmix-container"
          ref="rx-fitmix-container"
          class="relative aspect-[1920/1075] size-full"
        ></div>
        <button
          data-testid="close-button"
          class="absolute right-4 top-4 z-10 cursor-pointer rounded-full bg-white/30 p-2"
          :aria-label="$t('modal.close')"
          @click="() => emit('onVtoClose')"
        >
          <LazyIconFielmannClose class="size-6" />
        </button>
      </div>
    </ClientOnly>

    <div class="absolute inset-x-0 bottom-4 flex justify-center md:bottom-16">
      <FimButton
        v-if="!isOpen"
        type="secondary"
        :disabled="!fitMixReady"
        data-testid="virtual-try-on-button-rx"
        @click="(event: Event) => emit('onVtoOpen', event)"
      >
        <template #icon>
          <LazyIconFielmannWebcam class="size-4 md:size-6" />
        </template>
        {{ $t('vto.button_label') }}
      </FimButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  isOpen: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  lensColor: {
    type: String as PropType<string>,
    default: undefined,
  },
  fitMixReady: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  setupInitialization: {
    type: Function as PropType<
      (containerRef: Ref<HTMLDivElement | undefined>) => {
        stop: () => void
        cleanup: () => void
      }
    >,
    required: true,
  },
})

const emit = defineEmits<{
  (e: 'onVtoClose'): void
  (e: 'onVtoOpen', event: Event): void
}>()

// VTO setup
const container = useTemplateRef<HTMLDivElement>('rx-fitmix-container')
const containerRef = computed(() => container.value || undefined)
const { stop, cleanup } = props.setupInitialization(containerRef)

onScopeDispose(() => stop())
onBeforeUnmount(() => cleanup())
</script>
